// Generated by ReScript, PLEASE EDIT WITH CARE


var ga_fare_estimate_successful = "Get Trip Estimate Successful";

var ga_fare_estimate_successful_2w = "Get Trip Estimate Successful - 2W";

var ga_fare_estimate_successful_trucks = "Get Trip Estimate Successful - Trucks";

var ga_fare_estimate_successful_partload = "Get Trip Estimate Successful - Partload";

var ga_fare_estimate_successful_pnm = "Proceed Button Succeed";

var ga_fare_estimate_form_validation = "Get Trip Estimate Validation Successful";

var ga_fare_estimate_successful_event_parameter = "GTES Event Paramenter";

var pnm_ga_event_parameter_label = "PNM Event Parameter";

var enterprise_ga_event_parameter_label = "Enterprise Event Parameter";

var enterprise_ga_event_parameter_label_v2 = "Enterprise Form Event Parameter V2";

var api_integrations_event_parameter_label = "API Integrations Event Parameter";

var ga_fare_estimate_form_validation_error = "Get Trip Estimate Validation Error";

var ga_courier_estimate_successful = "Get Courier Estimate Successful - Home";

var ga_courier_estimate_failure = "Get Courier Estimate Failure";

var courier_ga_event_parameter_label = "Courier Event Parameter";

var gtes_unregistered_action_name = "GTES_Unregistered";

var compareEventLabel = "Compare Event";

var ga_courier_quotation_new_user_web = "courier_quotation_new_user_web";

export {
  ga_fare_estimate_successful ,
  ga_fare_estimate_successful_2w ,
  ga_fare_estimate_successful_trucks ,
  ga_fare_estimate_successful_partload ,
  ga_fare_estimate_successful_pnm ,
  ga_fare_estimate_form_validation ,
  ga_fare_estimate_successful_event_parameter ,
  pnm_ga_event_parameter_label ,
  enterprise_ga_event_parameter_label ,
  enterprise_ga_event_parameter_label_v2 ,
  api_integrations_event_parameter_label ,
  ga_fare_estimate_form_validation_error ,
  ga_courier_estimate_successful ,
  ga_courier_estimate_failure ,
  courier_ga_event_parameter_label ,
  gtes_unregistered_action_name ,
  compareEventLabel ,
  ga_courier_quotation_new_user_web ,
}
/* No side effect */
